var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isLeaved
    ? _c("div", { staticClass: "modal-cover", on: { click: _vm.onClose } }, [
        _c(
          "div",
          {
            staticClass: "my-setting-container",
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            _c("div", { staticClass: "my-setting-header-container" }, [
              !_vm.isOpenModifyDataModal
                ? _c("button", {
                    staticClass: "close-modal",
                    on: { click: _vm.onClose },
                  })
                : _vm.isOpenModifyDataModal
                ? _c("button", {
                    staticClass: "previous-modal",
                    on: { click: _vm.onPreviousModal },
                  })
                : _vm._e(),
              _c("div", { staticClass: "header-title" }, [
                _vm._v(_vm._s(_vm.getTitle)),
              ]),
              !_vm.isOpenModifyDataModal
                ? _c(
                    "button",
                    { staticClass: "save-btn", on: { click: _vm.onSubmit } },
                    [_vm._v(_vm._s(_vm.$t("common.save")))]
                  )
                : _vm.isOpenModifyDataModal &&
                  _vm.modifyDataType !== "vacancyDetection"
                ? _c(
                    "button",
                    {
                      staticClass: "save-btn",
                      on: { click: _vm.onSaveTempData },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.save")))]
                  )
                : _vm.isOpenModifyDataModal &&
                  _vm.modifyDataType === "vacancyDetection"
                ? _c(
                    "button",
                    {
                      staticClass: "save-btn",
                      on: { click: _vm.onSaveTempVacancy },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.save")))]
                  )
                : _vm._e(),
            ]),
            !_vm.isOpenModifyDataModal
              ? _c("ul", { staticClass: "my-setting-body-container" }, [
                  _c(
                    "li",
                    {
                      staticClass: "my-setting-item",
                      on: {
                        click: function ($event) {
                          return _vm.onOpenModifyDataModal("studyLevel")
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "setting-item-title flex items-center" },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("camstudy.roomSetting.studyLevel"))
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "setting-item-content flex items-center",
                        },
                        [
                          _vm.showPremiumPlus
                            ? _c(
                                "div",
                                {
                                  staticClass: "study-level",
                                  class: { premiumPlus: true },
                                },
                                [_vm._v("Premium+")]
                              )
                            : _vm._e(),
                          _vm.showPremium
                            ? _c(
                                "div",
                                {
                                  staticClass: "study-level",
                                  class: { premium: true },
                                },
                                [_vm._v("Premium")]
                              )
                            : _vm._e(),
                          _vm.showFreePlus
                            ? _c(
                                "div",
                                {
                                  staticClass: "study-level",
                                  class: { freePlus: true },
                                },
                                [_vm._v("Free")]
                              )
                            : _vm._e(),
                          _c("img", {
                            staticClass: "w-8 h-8",
                            attrs: {
                              src: require("@/assets/images/camstudy/ico_arrowRight_gray.svg"),
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "li",
                    {
                      staticClass: "my-setting-item",
                      on: {
                        click: function ($event) {
                          return _vm.onOpenModifyDataModal("studyTitle")
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "setting-item-title flex items-center" },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("camstudy.roomSetting.studyTitle"))
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "setting-item-content flex items-center",
                        },
                        [
                          _vm._v(" " + _vm._s(_vm.studyTitle) + " "),
                          _c("img", {
                            staticClass: "w-8 h-8",
                            attrs: {
                              src: require("@/assets/images/camstudy/ico_arrowRight_gray.svg"),
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _c("li", { staticClass: "my-setting-item with-desc" }, [
                    _c("div", { staticClass: "setting-item-title relative" }, [
                      _c("div", { staticClass: "flex" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("camstudy.roomSetting.openType.title")
                            ) +
                            " "
                        ),
                        _c("div", {
                          staticClass: "is-public-info-toggle",
                          on: { click: _vm.onOpenPublicModal },
                        }),
                      ]),
                      _vm.isOpenPublicModal
                        ? _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "click-outside",
                                  rawName: "v-click-outside",
                                  value: _vm.onClosePublicModal,
                                  expression: "onClosePublicModal",
                                },
                              ],
                              staticClass: "popup-is-public z-50",
                            },
                            [
                              _c("div", {
                                staticClass:
                                  "close-modal absolute right-5 top-5",
                                on: { click: _vm.onClosePublicModal },
                              }),
                              _c("div", { staticClass: "public-info" }, [
                                _c(
                                  "div",
                                  { staticClass: "public-info-title" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "camstudy.roomSetting.openType.public.title"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "public-info-content" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "camstudy.roomSetting.openType.public.desc1"
                                          )
                                        ) +
                                        " "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "camstudy.roomSetting.openType.public.desc2"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "public-info" }, [
                                _c(
                                  "div",
                                  { staticClass: "public-info-title" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "camstudy.roomSetting.openType.private.title"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "public-info-content" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "camstudy.roomSetting.openType.private.desc1"
                                          )
                                        ) +
                                        " "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "camstudy.roomSetting.openType.private.desc2"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _c("pre", { staticClass: "content-description" }, [
                        _vm._v(
                          _vm._s(_vm.$t("camstudy.roomSetting.openType.desc"))
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "setting-item-content is-public-container",
                      },
                      [
                        _c("div", { staticClass: "is-public-content" }, [
                          _vm._v(_vm._s(_vm.openType)),
                        ]),
                      ]
                    ),
                  ]),
                  _c(
                    "li",
                    {
                      staticClass: "my-setting-item with-desc",
                      on: {
                        click: function ($event) {
                          return _vm.onOpenModifyDataModal("definePasswd")
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "setting-item-title" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("camstudy.roomSetting.definePasswd")
                            ) +
                            " "
                        ),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "setting-item-content flex items-center",
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.currentDefinePasswdInfo) + " "
                          ),
                          _c("img", {
                            staticClass: "w-8 h-8",
                            attrs: {
                              src: require("@/assets/images/camstudy/ico_arrowRight_gray.svg"),
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _c("li", { staticClass: "my-setting-item" }, [
                    _c(
                      "div",
                      { staticClass: "setting-item-title flex items-center" },
                      [_vm._v(_vm._s(_vm.$t("camstudy.roomSetting.mainImage")))]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "setting-item-content image",
                        on: { click: _vm.onToggleRoomImageSetUpModal },
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: _vm.roomImage.url,
                            alt: _vm.$t("camstudy.roomSetting.mainImage"),
                          },
                        }),
                      ]
                    ),
                  ]),
                  _c(
                    "li",
                    {
                      staticClass: "my-setting-item",
                      on: {
                        click: function ($event) {
                          return _vm.onOpenModifyDataModal("hashTagList")
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "setting-item-title flex items-center justify-center",
                        },
                        [_vm._v(_vm._s(_vm.$t("camstudy.roomSetting.hashtag")))]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "setting-item-content flex items-center",
                        },
                        [
                          _vm._v(" " + _vm._s(_vm.currentHashTagInfo) + " "),
                          _c("img", {
                            staticClass: "w-8 h-8",
                            attrs: {
                              src: require("@/assets/images/camstudy/ico_arrowRight_gray.svg"),
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _c("li", { staticClass: "my-setting-item" }, [
                    _c(
                      "div",
                      { staticClass: "setting-item-title flex items-center" },
                      [_vm._v(_vm._s(_vm.$t("camstudy.roomSetting.period")))]
                    ),
                    _c("div", { staticClass: "setting-item-content" }, [
                      _c("div", { staticClass: "flex" }, [
                        _c("div", { staticClass: "date-container" }, [
                          _c("div", { staticClass: "date-input" }, [
                            _vm._v(_vm._s(_vm.formatStartDate)),
                          ]),
                        ]),
                        _c("div", { staticClass: "ml-2 mr-2" }, [_vm._v("~")]),
                        _c("div", { staticClass: "date-container" }, [
                          _c(
                            "button",
                            {
                              staticClass: "date-input",
                              on: { click: () => _vm.openDate("date2") },
                            },
                            [
                              _vm._v(_vm._s(_vm.formatEndResvDate)),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.endResvDate,
                                    expression: "endResvDate",
                                  },
                                ],
                                ref: "date2",
                                attrs: {
                                  type: "date",
                                  min: _vm.minDate,
                                  max: _vm.maxDate,
                                },
                                domProps: { value: _vm.endResvDate },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.endResvDate = $event.target.value
                                  },
                                },
                              }),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c("li", { staticClass: "my-setting-item" }, [
                    _c(
                      "div",
                      { staticClass: "setting-item-title flex items-center" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("camstudy.roomSetting.targetStudy.time")
                          )
                        ),
                      ]
                    ),
                    _c("div", { staticClass: "setting-item-content" }, [
                      _c("div", { staticClass: "flex gap-3 items-center" }, [
                        _c(
                          "div",
                          { staticClass: "w-24 select-container" },
                          [
                            _c("GrmCamstudySelect", {
                              attrs: {
                                name: "select-time",
                                list: _vm.targetStudyTimeSetting,
                                title: _vm.$t(
                                  "camstudy.roomSetting.targetStudy.time"
                                ),
                                value: _vm.targetSelected,
                              },
                              on: {
                                "update:value": function ($event) {
                                  _vm.targetSelected = $event
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.targetSelected && _vm.targetSelected !== "none"
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "w-32 flex gap-3 items-center justify-between",
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.targetTime,
                                      expression: "targetTime",
                                    },
                                  ],
                                  staticClass: "time-input",
                                  attrs: { type: "number", max: "24" },
                                  domProps: { value: _vm.targetTime },
                                  on: {
                                    input: [
                                      function ($event) {
                                        if ($event.target.composing) return
                                        _vm.targetTime = $event.target.value
                                      },
                                      _vm.filterNumberInput,
                                    ],
                                  },
                                }),
                                _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "camstudy.roomSetting.targetStudy.hour"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                  _c("li", { staticClass: "my-setting-item with-desc" }, [
                    _c("div", { staticClass: "setting-item-title" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("camstudy.roomSetting.pointSystem")) +
                          " "
                      ),
                      _c("div", { staticClass: "content-description" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "camstudy.roomSetting.pointSystemDescription"
                            )
                          )
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "setting-item-content flex gap-6" },
                      [
                        _c(
                          "div",
                          { staticClass: "flex gap-2" },
                          [
                            _c("GrmToggle", {
                              attrs: { "is-checked": _vm.usePoint },
                              on: {
                                "update:isChecked": function ($event) {
                                  _vm.usePoint = $event
                                },
                                "update:is-checked": function ($event) {
                                  _vm.usePoint = $event
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                  _c("li", { staticClass: "my-setting-item with-desc" }, [
                    _c("div", { staticClass: "setting-item-title" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("camstudy.roomSetting.initialDeviceSetting")
                          ) +
                          " "
                      ),
                      _c("div", { staticClass: "content-description" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "camstudy.roomSetting.deviceSettingDescription"
                            )
                          )
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "setting-item-content" }, [
                      _c("div", { staticClass: "flex gap-6" }, [
                        _c(
                          "div",
                          { staticClass: "flex gap-2" },
                          [
                            _c("GrmToggle", {
                              attrs: {
                                "is-checked": _vm.checkDefaultCameraStatus,
                              },
                              on: {
                                "update:isChecked": function ($event) {
                                  _vm.checkDefaultCameraStatus = $event
                                },
                                "update:is-checked": function ($event) {
                                  _vm.checkDefaultCameraStatus = $event
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: false,
                                expression: "false",
                              },
                            ],
                            staticClass: "flex gap-2",
                          },
                          [
                            _c("GrmToggle", {
                              attrs: {
                                "is-checked": _vm.checkDefaultMicStatus,
                              },
                              on: {
                                "update:isChecked": function ($event) {
                                  _vm.checkDefaultMicStatus = $event
                                },
                                "update:is-checked": function ($event) {
                                  _vm.checkDefaultMicStatus = $event
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                  _c(
                    "li",
                    {
                      staticClass: "my-setting-item",
                      on: {
                        click: function ($event) {
                          return _vm.onOpenModifyDataModal("studyEtiqutte")
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "setting-item-title flex items-center" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("camstudy.roomSetting.studyEtiquette")
                            )
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "setting-item-content flex items-center",
                        },
                        [
                          _c("div", { staticClass: "study-etiqutte-text" }, [
                            _vm._v(_vm._s(_vm.studyEtiqutte)),
                          ]),
                          _c("img", {
                            staticClass: "w-8 h-8",
                            attrs: {
                              src: require("@/assets/images/camstudy/ico_arrowRight_gray.svg"),
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "li",
                    {
                      staticClass: "my-setting-item with-desc",
                      on: {
                        click: function ($event) {
                          return _vm.onOpenModifyDataModal("vacancyDetection")
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "setting-item-title" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "camstudy.roomSetting.vacancyDetection.title"
                              )
                            ) +
                            " "
                        ),
                        _c("div", { staticClass: "content-description" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "camstudy.roomSetting.vacancyDetection.desc"
                              )
                            )
                          ),
                        ]),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "setting-item-content flex items-center",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.vacancyDetection || _vm.tempVacancyDetection
                                  ? _vm.$t(
                                      "camstudy.roomSetting.vacancyDetection.status.on"
                                    )
                                  : _vm.$t(
                                      "camstudy.roomSetting.vacancyDetection.status.off"
                                    )
                              ) +
                              " "
                          ),
                          _c("img", {
                            staticClass: "w-8 h-8",
                            attrs: {
                              src: require("@/assets/images/camstudy/ico_arrowRight_gray.svg"),
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm.isOpenModifyDataModal
              ? _c("div", { staticClass: "my-setting-body-container" }, [
                  _vm.modifyDataType === "studyTitle"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.tempInputData,
                            expression: "tempInputData",
                          },
                        ],
                        staticClass: "input-text",
                        attrs: {
                          type: "text",
                          placeholder: _vm.$t(
                            "camstudy.roomSetting.studyTitlePlaceholder"
                          ),
                        },
                        domProps: { value: _vm.tempInputData },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.tempInputData = $event.target.value
                          },
                        },
                      })
                    : _vm.modifyDataType === "hashTagList"
                    ? _c("div", [
                        _c("div", { staticClass: "hashtag-input-container" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.tag,
                                expression: "tag",
                              },
                            ],
                            staticClass: "hashtag-input",
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t(
                                "camstudy.roomSetting.hashtagPlaceholder"
                              ),
                              maxLength: "45",
                            },
                            domProps: { value: _vm.tag },
                            on: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                $event.preventDefault()
                                return _vm.onEnterAddTag.apply(null, arguments)
                              },
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.tag = $event.target.value
                              },
                            },
                          }),
                          _c("div", { staticClass: "add-button-container" }, [
                            _c(
                              "button",
                              {
                                staticClass: "add-button",
                                on: { click: _vm.onEnterAddTag },
                              },
                              [_vm._v(_vm._s(_vm.$t("camstudy.invite.add")))]
                            ),
                          ]),
                        ]),
                        _c(
                          "div",
                          { staticClass: "hashtag-list" },
                          _vm._l(_vm.tempInputData, function (tag, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "hashtag-item" },
                              [
                                _vm._v(" " + _vm._s(tag) + " "),
                                _c("button", {
                                  staticClass: "hashtag-delete",
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeTag(index)
                                    },
                                  },
                                }),
                              ]
                            )
                          }),
                          0
                        ),
                      ])
                    : _vm.modifyDataType === "studyEtiqutte"
                    ? _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.tempInputData,
                            expression: "tempInputData",
                          },
                        ],
                        attrs: { maxlength: "1000" },
                        domProps: { value: _vm.tempInputData },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.tempInputData = $event.target.value
                          },
                        },
                      })
                    : _vm.modifyDataType === "vacancyDetection"
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "vacancy-detection-image-container" },
                          [
                            _c("div", {
                              staticClass: "vacancy-detection-image",
                            }),
                            _c(
                              "div",
                              { staticClass: "vacancy-title-container" },
                              [
                                _c("h4", { staticClass: "vacancy-title" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "camstudy.roomSetting.vacancyDetection.title"
                                      )
                                    )
                                  ),
                                ]),
                                _c("p", { staticClass: "vacancy-text" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "camstudy.roomSetting.vacancyDetection.desc"
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        ),
                        _c("div", { staticClass: "my-setting-item" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "setting-item-title flex items-center",
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "camstudy.roomSetting.vacancyDetection.title"
                                  )
                                )
                              ),
                            ]
                          ),
                          _c("div", { staticClass: "setting-item-content" }, [
                            _c("div", { staticClass: "flex gap-6" }, [
                              _c(
                                "div",
                                { staticClass: "flex gap-2" },
                                [
                                  _c("GrmToggle", {
                                    attrs: {
                                      "is-checked": _vm.tempVacancyDetection,
                                      disabled: !_vm.isVacancyDetectionEnabled,
                                    },
                                    on: {
                                      "update:isChecked": function ($event) {
                                        _vm.tempVacancyDetection = $event
                                      },
                                      "update:is-checked": function ($event) {
                                        _vm.tempVacancyDetection = $event
                                      },
                                      onDisabled: _vm.onDisabled,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "my-setting-item" }, [
                          _c(
                            "div",
                            { staticClass: "setting-item-title flex flex-col" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "camstudy.roomSetting.vacancyDetection.options.allowance.title"
                                    )
                                  ) +
                                  " "
                              ),
                              _c(
                                "pre",
                                { staticClass: "content-description" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "camstudy.roomSetting.vacancyDetection.options.allowance.desc"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "setting-item-content vacancy-input-container",
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.tempVacancyMinutes,
                                    expression: "tempVacancyMinutes",
                                  },
                                ],
                                staticClass: "vacancy-time-input",
                                attrs: {
                                  max: "60",
                                  type: "number",
                                  disabled: !_vm.tempVacancyDetection,
                                },
                                domProps: { value: _vm.tempVacancyMinutes },
                                on: {
                                  blur: _vm.onBlurVacancyTime,
                                  input: [
                                    function ($event) {
                                      if ($event.target.composing) return
                                      _vm.tempVacancyMinutes =
                                        $event.target.value
                                    },
                                    _vm.filterVacancyTimerNumberInput,
                                  ],
                                },
                              }),
                              _c("div", { staticClass: "vacancy-time-text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "camstudy.roomSetting.vacancyDetection.options.allowance.unit"
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]),
                      ])
                    : _vm.modifyDataType === "studyLevel"
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            staticClass: "my-setting-item",
                            on: {
                              click: () =>
                                _vm.onClickStudyLevelRadio("premium-plus"),
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "setting-item-title flex items-center",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "study-level",
                                    class: {
                                      freePlus: false,
                                      premium: false,
                                      premiumPlus: true,
                                    },
                                  },
                                  [_vm._v("Premium+")]
                                ),
                              ]
                            ),
                            _c("div", { staticClass: "setting-item-content" }, [
                              _c("div", { staticClass: "flex gap-6" }, [
                                _c("div", { staticClass: "flex gap-2" }, [
                                  _c("input", {
                                    ref: "premium-plus",
                                    attrs: {
                                      type: "radio",
                                      name: "study-level",
                                      checked: "",
                                    },
                                  }),
                                ]),
                              ]),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "my-setting-item",
                            on: {
                              click: () =>
                                _vm.onClickStudyLevelRadio("premium"),
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "setting-item-title flex items-center",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "study-level",
                                    class: { not: true },
                                  },
                                  [_vm._v("Premium")]
                                ),
                              ]
                            ),
                            _c("div", { staticClass: "setting-item-content" }, [
                              _c("div", { staticClass: "flex gap-6" }, [
                                _c("div", { staticClass: "flex gap-2" }, [
                                  _c("input", {
                                    ref: "premium",
                                    attrs: {
                                      type: "radio",
                                      name: "study-level",
                                    },
                                  }),
                                ]),
                              ]),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "my-setting-item",
                            on: {
                              click: () =>
                                _vm.onClickStudyLevelRadio("free-plus"),
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "setting-item-title flex items-center",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "study-level",
                                    class: { not: true },
                                  },
                                  [_vm._v("Free")]
                                ),
                              ]
                            ),
                            _c("div", { staticClass: "setting-item-content" }, [
                              _c("div", { staticClass: "flex gap-6" }, [
                                _c("div", { staticClass: "flex gap-2" }, [
                                  _c("input", {
                                    ref: "free-plus",
                                    attrs: {
                                      type: "radio",
                                      name: "study-level",
                                    },
                                  }),
                                ]),
                              ]),
                            ]),
                          ]
                        ),
                        _vm.isFreeRoom
                          ? _c(
                              "div",
                              { staticClass: "my-setting-item temp-btn-area" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "free-v2-btn",
                                    staticStyle: { display: "none" },
                                    on: {
                                      click: () =>
                                        _vm.onClickStudyLevelRadio("free-v2"),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("camstudy.roomSetting.backToV2")
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ])
                    : _vm.modifyDataType === "definePasswd"
                    ? _c("div", [
                        _c("div", { staticClass: "define-passwd-container" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.definePasswdValue,
                                expression: "definePasswdValue",
                              },
                            ],
                            staticClass: "define-passwd-input",
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t(
                                "camstudy.roomSetting.definePasswdPlaceholder"
                              ),
                              maxLength: "100",
                            },
                            domProps: { value: _vm.definePasswdValue },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.definePasswdValue = $event.target.value
                              },
                            },
                          }),
                        ]),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
          ]
        ),
        _c(
          "div",
          {
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            _vm.isOpenImageSettingModal
              ? _c("RoomImageSettingModal", {
                  on: {
                    close: _vm.onToggleRoomImageSetUpModal,
                    confirm: _vm.onChangeRoomImage,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }